<script lang="ts" setup>
  import { boolean, object, string } from 'yup'
  import { useForm } from 'vee-validate'
  import ButtonDefault from '@/elements/ButtonDefault.vue'
  import { useFeatureFlags } from '@/composables/useFeatureFlag.ts'

  const isVisible = defineModel<boolean>('isVisible', { required: true })
  const emit = defineEmits(['submit'])
  const featureFlags = useFeatureFlags()
  const postError = ref()

  const schema = object().shape({
    name: string().required('Name ist erforderlich').min(5),
    location: string()
      .required('Location ist erforderlich')
      .oneOf(['frontend', 'backend', 'shared'], 'Ungültige Location. Erlaubt sind: Client, Server, Client+Server'),
    notes: string().notRequired().nullable(),
    enabled: boolean().required('Status ist erforderlich')
  })

  const initialValues = {
    name: '',
    location: 'frontend',
    notes: '',
    enabled: false
  }

  const { values, defineField, handleSubmit, errors, resetForm } = useForm({
    validationSchema: schema,
    initialValues: initialValues
  })

  const [name] = defineField('name')
  const [location] = defineField('location')
  const [notes] = defineField('notes')
  const [enabled] = defineField('enabled')

  const locationSelectOptions = ref([
    { label: 'Client', value: 'frontend' },
    { label: 'Server', value: 'backend' },
    { label: 'Client+Server', value: 'shared' }
  ])

  const onSubmit = handleSubmit(async () => {
    //emit('submit', values)
    //isVisible.value = false
    postError.value = ''
    try {
      await featureFlags.addFlag(values)
      emit('submit', values)
      isVisible.value = false
    } catch (error) {
      postError.value = 'Ein Feature-Flag mit diesem Namen ist schon vorhanden'
    }
  })

  const onDialogHide = () => {
    resetForm({
      values: initialValues
    })
    postError.value = ''
  }
</script>
<template>
  <Dialog
    v-if="isVisible"
    v-model:visible="isVisible"
    header="Feature Flag hinzufügen"
    modal
    @update:visible="onDialogHide">
    <form @submit="onSubmit">
      <div class="mt-2 w-full md:flex justify-between items-center grid grid-cols-1">
        <FloatLabel variant="on" class="md:w-[40%]">
          <label>Name</label>
          <InputText
            v-model="name"
            class="w-full h-[42px]"
            :invalid="!!errors.name || !!postError" />
        </FloatLabel>
        <FloatLabel variant="on" class="w-full md:mx-2 my-2 md:my-0 md:w-[40%]">
          <Select
            v-model="location"
            class="w-full"
            inputId="on_label"
            :options="locationSelectOptions"
            optionLabel="label"
            optionValue="value"
            :invalid="!!errors.location" />
          <label for="on_label">Location</label>
        </FloatLabel>
        <div class="md:w-[20%]">
          <ToggleButton
            v-model="enabled"
            onLabel="Aktiv"
            offLabel="Inaktiv"
            size="small"
            class="w-full  h-[42px]"
            :invalid="!!errors.enabled" />
        </div>
      </div>
      <div class="w-full mt-2">
        <Editor
          v-model="notes"
          editorStyle="height: 150px" />
      </div>
      <Message v-if="Object.keys(errors).length" severity="error">
        <p v-for="error in errors">
          {{ error }}
        </p>
      </Message>
      <Message v-if="postError" severity="error">
        {{ postError }}
      </Message>
      <div class="flex justify-end mt-2">
        <ButtonDefault
          label="Absenden"
          icon="SendIcon"
          outlined
          size="small"
          class="w-full md:w-auto"
          type="submit" />
      </div>
    </form>
  </Dialog>
</template>
